import { Icon, IconProps } from './Icon';

interface AddPhoneIconProps extends IconProps {
  gradient?: {
    id: string;
    stops: { offset: string; color: string }[];
  };
}

export const AddPhoneIcon = ({ color = '#5E6A81', gradient, ...props }: AddPhoneIconProps) => (
  <Icon
    {...props}
    viewBox="0 0 25 24"
  >
    <defs>
      {gradient && (
        <linearGradient
          id={gradient.id}
          x1="80%"
          y1="20%"
          x2="20%"
          y2="80%"
        >
          {gradient.stops.map((stop, index) => (
            <stop
              key={index}
              offset={stop.offset}
              stopColor={stop.color}
            />
          ))}
        </linearGradient>
      )}
    </defs>
    <path
      d="M8.5 3C9 3 11 7.5 11 8C11 9 9.5 10 9 11C8.5 12 9.5 13 10.5 14C10.89 14.39 12.5 16 13.5 15.5C14.5 15 15.5 13.5 16.5 13.5C17 13.5 21.5 15.5 21.5 16C21.5 18 20 19.5 18.5 20C17 20.5 16 20.5 14 20C12 19.5 10.5 19 8 16.5C5.5 14 5 12.5 4.5 10.5C4 8.5 4 7.5 4.5 6C5 4.5 6.5 3 8.5 3Z"
      stroke={gradient ? `url(#${gradient.id})` : color}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M15.5 6H19.5"
      stroke={gradient ? `url(#${gradient.id})` : color}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M17.5 4V8"
      stroke={gradient ? `url(#${gradient.id})` : color}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </Icon>
);
